module.exports = __webpack_public_path__ + "assets/img/401.f85649d8.png";